import { render, staticRenderFns } from "./ProjectAanmaken.vue?vue&type=template&id=c8837c4c&"
import script from "./ProjectAanmaken.vue?vue&type=script&lang=js&"
export * from "./ProjectAanmaken.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAanmaken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectAanmaken.vue"
export default component.exports